import Mutations from '../../odata/mutations';

export default { ...new Mutations('deliveryOrder'), ...new Mutations('deliveryOrders') };
